import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'circle-letter-m', 'CircleLetterM', [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0"}],["path",{"d":"M9 16v-8l3 5l3 -5v8"}]]);